export default {"src":"/_next/static/media/paragliding.7dc60032.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};